export default __webpack_public_path__ + "static/media/ic_check_mark.6121af65.svg";